import TeamsProxy from '@/proxies/Teams';
import TeamsTransform from '@/transforms/Teams';
import * as types from './mutation-types';

export default {
  async create({ commit, dispatch }, payload) {
    commit(types.LOADING, true);
    const { afterAction, ...options } = payload;
    const proxy = new TeamsProxy();
    try {
      await proxy.create(options);
      await dispatch('refresh');
      afterAction();
      dispatch('notification/success', 'confirmationmessage.team_created', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_add_team', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async getItems({ commit, dispatch, getters }) {
    commit(types.LOADING, true);
    const proxy = new TeamsProxy();
    try {
      const response = await proxy.getTeams(getters.sort);
      commit(types.TEAMS, TeamsTransform.fetchCollection(response.teams));
      commit(types.MORE, response.total > getters.items.length);
      commit(types.TOTAL, response.total);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_teams', { root: true });
    } finally {
      commit(types.LOADING, false);
      commit(types.UPDATED);
    }
  },
  async getItem({ commit, dispatch }, payload) {
    const proxy = new TeamsProxy();
    try {
      const response = await proxy.find(payload);
      commit(types.TEAM, TeamsTransform.fetch(response.team));
    } catch (e) {
      dispatch('notification/error', ['errormessage.failed_to_get_team', {team_id: payload.id }], { root: true });
    }
  },
  addTeam({ commit }, payload) {
    commit(types.TEAMS, [payload]);
  },
  async deleteItem({ commit, state }, payload) {
    const proxy = new TeamsProxy();
    try {
      await proxy.delete(payload);
      commit(types.DELETE, payload);
      const deletionCount = Array.isArray(payload) ? payload.length : 1;
      commit(types.TOTAL, state.total - deletionCount);
    } catch (e) {
      // TODO
    }
  },
  sortItems({ commit, dispatch }, payload) {
    commit(types.SORT, payload);
    dispatch('getItems');
  },
  clearItems({ commit }) {
    commit(types.CLEAR_ITEMS);
  },
  resetFilter({ commit, dispatch, getters }) {
    commit(types.RESET_FILTER);
    dispatch('sortItems', getters.defaultSort);
  },
  async refresh({ commit, getters }) {
    const proxy = new TeamsProxy();
    try {
      const response = await proxy.getTeams({ ...getters.sort, ...{ page: 1, limit: getters.items.length } });
      commit(types.TEAMS, TeamsTransform.fetchCollection(response.teams));
    } catch (e) {
      // TODO
    } finally {
      commit(types.UPDATED);
    }
  },
  refreshLocally({ commit, dispatch, getters }, payload) {
    try {
      const result = getters.items.map(el => {
        if (el.id === payload._id) {
          return TeamsTransform.fetch(payload);
        }
        return el;
      });
      commit(types.TEAMS, result);
    } catch {
      dispatch('refresh');
    }
  },
  async update({ commit, dispatch }, payload) {
    commit(types.LOADING, true);
    const proxy = new TeamsProxy();
    try {
      const { id, ...options } = payload;
      const response = await proxy.update(id, options);
      dispatch('refreshLocally', response);
      dispatch('notification/success', 'confirmationmessage.team_updated', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_team', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
};
